import { createAsyncThunk } from '@reduxjs/toolkit';
import { serializeError } from 'shared/utils/redux';
import { FetchGlobalQuestionLibraryChangesParams } from 'api/GlobalQuestionLibraryApi';
import { globalQuestionLibraryApi } from 'container/globalQuestionLibraryApi';

import { STORE_NAME } from './initialState';

export const fetchGlobalQuestionLibraryQuestions = createAsyncThunk(
  `${STORE_NAME}/fetchGlobalQuestionLibraryQuestions`,
  () => {
    return globalQuestionLibraryApi.fetchQuestions();
  },
  { serializeError },
);

export const fetchGlobalQuestionLibraryCategories = createAsyncThunk(
  `${STORE_NAME}/fetchGlobalQuestionLibraryCategories`,
  () => {
    return globalQuestionLibraryApi.fetchCategories();
  },
  { serializeError },
);

export const fetchGlobalQuestionLibraryChanges = createAsyncThunk(
  `${STORE_NAME}/fetchGlobalQuestionLibraryChanges`,
  (params: FetchGlobalQuestionLibraryChangesParams) => {
    return globalQuestionLibraryApi.fetchChanges(params);
  },
  { serializeError },
);
